// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32ef8836","667":"ef131096"}[chunkId] + ".chunk.js";
};